import React from 'react'

const IphoneFillIcon16oxSvg = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <g clipPath="url(#clip0_139_22886)">
                <path d="M3 2.44897C3 1.91854 3.21071 1.40983 3.58579 1.03476C3.96086 0.659688 4.46957 0.448975 5 0.448975L11 0.448975C11.5304 0.448975 12.0391 0.659688 12.4142 1.03476C12.7893 1.40983 13 1.91854 13 2.44897V14.449C13 14.9794 12.7893 15.4881 12.4142 15.8632C12.0391 16.2383 11.5304 16.449 11 16.449H5C4.46957 16.449 3.96086 16.2383 3.58579 15.8632C3.21071 15.4881 3 14.9794 3 14.449V2.44897ZM9 13.449C9 13.1838 8.89464 12.9294 8.70711 12.7419C8.51957 12.5543 8.26522 12.449 8 12.449C7.73478 12.449 7.48043 12.5543 7.29289 12.7419C7.10536 12.9294 7 13.1838 7 13.449C7 13.7142 7.10536 13.9685 7.29289 14.1561C7.48043 14.3436 7.73478 14.449 8 14.449C8.26522 14.449 8.51957 14.3436 8.70711 14.1561C8.89464 13.9685 9 13.7142 9 13.449Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_139_22886">
                    <rect width="16" height="16" fill="white" transform="translate(0 0.448975)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default IphoneFillIcon16oxSvg